"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactBootstrap = require("react-bootstrap");
var _questionHelper = require("../questionHelper");
var CustomReadOnlyQuestion = function CustomReadOnlyQuestion(props) {
  var question = props.question;
  var displayValue = question.defaultValue || question.value;
  var corrected = (0, _questionHelper.correctDefaultValue)(question, displayValue);
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormControl, {
    className: "sd-text",
    disabled: question.isReadOnly,
    value: corrected || displayValue
  });
};
CustomReadOnlyQuestion.propTypes = {
  question: _propTypes.default.shape({
    defaultValue: _propTypes.default.string.isRequired,
    value: _propTypes.default.string.isRequired,
    isReadOnly: _propTypes.default.bool.isRequired
  }).isRequired
};
CustomReadOnlyQuestion.defaultProps = {};
var _default = CustomReadOnlyQuestion;
exports.default = _default;